import { Card, Button } from '@/components/UI';
import SearchSelect from '@/components/UI/SearchSelect';
import type { ScorecardListItem, ScorecardStrategyContext } from './types';

interface ScorecardTargetCardProps {
    filteredScorecards: ScorecardListItem[];
    isLoading: boolean;
    onSelect: (id: number | null) => void;
    strategyContext: ScorecardStrategyContext | null;
    selectedScorecardIdTop: number | null;
}

const ScorecardTargetCard = ({
    filteredScorecards,
    isLoading,
    onSelect,
    strategyContext,
    selectedScorecardIdTop
}: ScorecardTargetCardProps) => {
    return (
        <Card className="bg-zinc-900 p-4">
            <div className="flex flex-col gap-3 xl:flex-row xl:items-end xl:justify-between">
                <div className="min-w-0 xl:max-w-xl">
                    <SearchSelect
                        noMargin
                        isLoading={isLoading}
                        items={filteredScorecards.map((s) => ({
                            badge: s.initializationStatus === 'ready' ? 'ready · editable' : s.initializationStatus,
                            label: s.name,
                            name: s.name,
                            value: s.id
                        }))}
                        label="Scorecard Target"
                        mode="single"
                        placeholder={filteredScorecards.length === 0 ? 'No scorecards for this analysis' : 'Choose a scorecard'}
                        value={selectedScorecardIdTop}
                        onChange={onSelect}
                    />
                </div>
                {selectedScorecardIdTop && strategyContext && (
                    <div className="flex flex-wrap gap-2">
                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() =>
                                window.open(`/user/scorecard/${selectedScorecardIdTop}?strategyId=${strategyContext.strategyId}`, '_blank')
                            }
                        >
                            Open Editor
                        </Button>
                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => window.open(`/user/scorecards?strategyId=${strategyContext.strategyId}`, '_blank')}
                        >
                            Open Manager
                        </Button>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default ScorecardTargetCard;
